/**
 * Universal Logger Export
 * Automatically exports server or client logger based on environment
 */
import { createLogger as clientCreateLogger, logger as clientLogger, loggers as clientLoggers } from './logger.client';
import { createLogger as serverCreateLogger, logger as serverLogger, loggers as serverLoggers } from './logger.server';

// Detect environment
const isServer = typeof window === 'undefined';

// Export the appropriate logger based on environment
export const logger = isServer ? serverLogger : clientLogger;
export const createLogger = isServer ? serverCreateLogger : clientCreateLogger;
export const loggers = isServer ? serverLoggers : clientLoggers;

export type ILogger = typeof logger;
